import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { interpolate, useAnimatedStyle } from 'react-native-reanimated';

import { common, designSystem } from '@/styles/styles';
import { isWeb } from '@/utils/constants-platform-specific';

import { useFantasyFullScreenPagerTransition } from './FantasyFullScreenPagerTransitionProvider';

/**
 * component that renders the black background behind each event sheet
 * the component is animated on mount using sheetMountAnimationProgress shared value
 * after the mount animation is done, the component is animated based on the animatedIndex shared value
 */
export const SheetBackground = memo(() => {
    const { sheetMountAnimationProgress, animatedIndex, isSheetMountCompleted } = useFantasyFullScreenPagerTransition();
    const mountingAnimation = useAnimatedStyle(() => {
        return {
            opacity: interpolate(sheetMountAnimationProgress.value, [-1, -0.7, 0], [0, 1, 1]),
        };
    });

    const bottomSheetGestureStyles = useAnimatedStyle(() => {
        if (!isSheetMountCompleted.value) {
            return {};
        }

        return {
            opacity: interpolate(animatedIndex.value, [-1, 0], [0, 1]),
        };
    });

    return (
        <Animated.View
            style={[
                StyleSheet.absoluteFill,
                common.zIndexNegative1,
                { backgroundColor: isWeb ? designSystem.colors.gray8 : designSystem.colors.neutralBlack },
                mountingAnimation,
                bottomSheetGestureStyles,
            ]}
        />
    );
});
